var map = {
	".": 44048,
	"./": 44048,
	"./App": 9555,
	"./App.css": 93508,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Catalogue": 61250,
	"./Catalogue.css": 83914,
	"./Catalogue.js": 61250,
	"./Diary": 9607,
	"./Diary.css": 60195,
	"./Diary.js": 9607,
	"./Footer": 10705,
	"./Footer.js": 10705,
	"./Home": 28869,
	"./Home.css": 87117,
	"./Home.js": 28869,
	"./Montserrat (2).zip": 72499,
	"./Montserrat (2)/Montserrat-Italic-VariableFont_wght.ttf": 64795,
	"./Montserrat (2)/Montserrat-VariableFont_wght.ttf": 18941,
	"./Montserrat (2)/OFL.txt": 86541,
	"./Montserrat (2)/README.txt": 62577,
	"./Montserrat (2)/static/Montserrat-Black.ttf": 37731,
	"./Montserrat (2)/static/Montserrat-BlackItalic.ttf": 21332,
	"./Montserrat (2)/static/Montserrat-Bold.ttf": 64047,
	"./Montserrat (2)/static/Montserrat-BoldItalic.ttf": 68952,
	"./Montserrat (2)/static/Montserrat-ExtraBold.ttf": 88659,
	"./Montserrat (2)/static/Montserrat-ExtraBoldItalic.ttf": 12238,
	"./Montserrat (2)/static/Montserrat-ExtraLight.ttf": 54460,
	"./Montserrat (2)/static/Montserrat-ExtraLightItalic.ttf": 46537,
	"./Montserrat (2)/static/Montserrat-Italic.ttf": 91786,
	"./Montserrat (2)/static/Montserrat-Light.ttf": 63942,
	"./Montserrat (2)/static/Montserrat-LightItalic.ttf": 49269,
	"./Montserrat (2)/static/Montserrat-Medium.ttf": 79086,
	"./Montserrat (2)/static/Montserrat-MediumItalic.ttf": 42495,
	"./Montserrat (2)/static/Montserrat-Regular.ttf": 74118,
	"./Montserrat (2)/static/Montserrat-SemiBold.ttf": 62027,
	"./Montserrat (2)/static/Montserrat-SemiBoldItalic.ttf": 42524,
	"./Montserrat (2)/static/Montserrat-Thin.ttf": 49706,
	"./Montserrat (2)/static/Montserrat-ThinItalic.ttf": 71079,
	"./Navigation": 12631,
	"./Navigation.css": 94982,
	"./Navigation.js": 12631,
	"./Open Fashion App (Community) (Community).fig": 60139,
	"./Referral": 34981,
	"./Referral.css": 55074,
	"./Referral.js": 34981,
	"./STYclick brand guide.pdf": 91138,
	"./TenorSans-Regular.woff": 57988,
	"./Wallet": 583,
	"./Wallet.css": 68025,
	"./Wallet.js": 583,
	"./config-overrides": 75448,
	"./config-overrides.js": 75448,
	"./font.zip": 48235,
	"./index": 44048,
	"./index.css": 51174,
	"./index.js": 44048,
	"./logo.svg": 31100,
	"./pictures/12083723_Wavy_Bus-37_Single-03.jpg": 28749,
	"./pictures/IMG-20220824-WA0005.jpg": 49000,
	"./pictures/IMG-20220824-WA0006.jpg": 32655,
	"./pictures/IMG-20220824-WA0007.jpg": 22362,
	"./pictures/IMG-20220824-WA0008.jpg": 52349,
	"./pictures/IMG-20220824-WA0009.jpg": 94962,
	"./pictures/IMG-20220824-WA0010.jpg": 8040,
	"./pictures/IMG-20220824-WA0011.jpg": 56813,
	"./pictures/IMG-20220824-WA0012.jpg": 22064,
	"./pictures/IMG-20220824-WA0013.jpg": 85132,
	"./pictures/IMG-20220824-WA0014.jpg": 41161,
	"./pictures/IMG-20220824-WA0015.jpg": 3071,
	"./pictures/IMG-20220824-WA0016.jpg": 35735,
	"./pictures/IMG-20220824-WA0017.jpg": 25,
	"./pictures/IMG-20220824-WA0018.jpg": 97098,
	"./pictures/IMG-20220824-WA0019.jpg": 89735,
	"./pictures/IMG-20220824-WA0020.jpg": 97334,
	"./pictures/IMG-20220824-WA0061.jpg": 70701,
	"./pictures/IMG-20220824-WA0062.jpg": 68658,
	"./pictures/IMG-20220824-WA0063.jpg": 42838,
	"./pictures/IMG-20220824-WA0064.jpg": 94359,
	"./pictures/IMG-20220824-WA0065.jpg": 78234,
	"./pictures/IMG-20220824-WA0066.jpg": 89814,
	"./pictures/IMG-20220824-WA0067.jpg": 98128,
	"./pictures/IMG-20220824-WA0068.jpg": 98671,
	"./pictures/IMG-20220824-WA0069.jpg": 52262,
	"./pictures/IMG-20220824-WA0070.jpg": 52047,
	"./pictures/IMG-20220824-WA0071.jpg": 16924,
	"./pictures/IMG-20220824-WA0072.jpg": 28548,
	"./pictures/IMG-20220824-WA0073.jpg": 27989,
	"./pictures/IMG-20220824-WA0074.jpg": 7260,
	"./pictures/IMG-20220824-WA0075.jpg": 76028,
	"./pictures/IMG-20220824-WA0076.jpg": 82898,
	"./pictures/IMG-20220824-WA0077.jpg": 93042,
	"./pictures/IMG-20220824-WA0078.jpg": 34330,
	"./pictures/IMG-20220824-WA0079.jpg": 7114,
	"./pictures/IMG-20220824-WA0080.jpg": 18325,
	"./pictures/IMG-20220824-WA0081.jpg": 65168,
	"./pictures/IMG-20220824-WA0082.jpg": 98162,
	"./pictures/IMG-20220824-WA0083.jpg": 58457,
	"./pictures/IMG-20220824-WA0084.jpg": 51349,
	"./pictures/IMG-20220824-WA0085.jpg": 71468,
	"./pictures/IMG-20220824-WA0086.jpg": 24263,
	"./pictures/IMG-20220824-WA0087.jpg": 97680,
	"./pictures/IMG-20220824-WA0088.jpg": 3166,
	"./pictures/IMG-20220824-WA0089.jpg": 87354,
	"./pictures/IMG-20220824-WA0090.jpg": 22161,
	"./pictures/IMG-20220824-WA0091.jpg": 27615,
	"./pictures/IMG-20220824-WA0092.jpg": 25368,
	"./pictures/IMG-20220824-WA0093.jpg": 53016,
	"./pictures/IMG-20220824-WA0094.jpg": 91135,
	"./pictures/IMG-20220824-WA0095.jpg": 7194,
	"./pictures/IMG-20220824-WA0096.jpg": 38785,
	"./pictures/IMG-20220824-WA0097.jpg": 14102,
	"./pictures/IMG-20220824-WA0098.jpg": 71047,
	"./pictures/IMG-20220824-WA0099.jpg": 97120,
	"./pictures/IMG-20220824-WA0100.jpg": 70600,
	"./pictures/IMG-20220824-WA0101.jpg": 63950,
	"./pictures/IMG-20220824-WA0102.jpg": 89809,
	"./pictures/IMG-20220824-WA0103.jpg": 4407,
	"./pictures/IMG-20220824-WA0104.jpg": 32843,
	"./pictures/IMG-20220824-WA0105.jpg": 95199,
	"./pictures/IMG-20220824-WA0106.jpg": 87271,
	"./pictures/IMG-20220824-WA0107.jpg": 45494,
	"./pictures/IMG-20220824-WA0108.jpg": 15162,
	"./pictures/IMG-20220824-WA0109.jpg": 36229,
	"./pictures/IMG-20220824-WA0110.jpg": 26694,
	"./pictures/IMG-20220824-WA0111.jpg": 9549,
	"./pictures/IMG-20220824-WA0112.jpg": 82945,
	"./pictures/IMG-20220824-WA0113.jpg": 76003,
	"./pictures/IMG-20220824-WA0114.jpg": 60788,
	"./pictures/IMG-20220824-WA0115.jpg": 76786,
	"./pictures/IMG-20220824-WA0116.jpg": 31782,
	"./pictures/IMG-20220824-WA0117.jpg": 3526,
	"./pictures/IMG-20220824-WA0118.jpg": 53876,
	"./pictures/IMG-20220824-WA0119.jpg": 35914,
	"./pictures/IMG-20220824-WA0120.jpg": 70196,
	"./pictures/IMG-20220824-WA0121.jpg": 25975,
	"./pictures/IMG-20220824-WA0122.jpg": 63596,
	"./pictures/IMG-20220824-WA0123.jpg": 91376,
	"./pictures/IMG-20220824-WA0124.jpg": 71491,
	"./pictures/IMG-20220824-WA0125.jpg": 90883,
	"./pictures/IMG-20220824-WA0126.jpg": 58440,
	"./pictures/IMG-20220825-WA0002.jpg": 52771,
	"./pictures/Open Fashion App (Community) (Community).fig": 30858,
	"./pictures/Rectangle 325 (1).png": 39999,
	"./pictures/Rectangle 325 (2).png": 32451,
	"./pictures/Rectangle 325 (3).png": 5274,
	"./pictures/Rectangle 325.png": 83481,
	"./pictures/Rectangle 344.png": 42303,
	"./pictures/STYclick brand guide.pdf": 51455,
	"./pictures/icons8-chat-32.png": 81592,
	"./pictures/icons8-chat-64.png": 92400,
	"./pictures/icons8-clothes-32.png": 17992,
	"./pictures/icons8-diary-80.png": 73950,
	"./pictures/icons8-torn-page-64.png": 14468,
	"./pictures/image 10.png": 84071,
	"./pictures/image 12.png": 82265,
	"./pictures/image 15.png": 92246,
	"./pictures/img.png": 6052,
	"./pictures/noun-chat-5064317.svg": 94390,
	"./pictures/noun-clothes-3511625.svg": 56050,
	"./pictures/noun-diary-5046353.svg": 19733,
	"./pictures/noun-wardrobe-5037907.svg": 5353,
	"./pictures/styclick 2.png": 77311,
	"./pictures/styclick brand guide 3.pdf": 36648,
	"./pictures/styclick.png": 68976,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./styclick 2.png": 40106,
	"./styclick.png": 23653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;